export default __webpack_public_path__ + "89edccdfa22b7da5d2ce44cad696e1ca.jpg";